import { Divider } from 'antd';

export default class Footer extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { type } = this.props;
        return (
            <div>
                <Divider 
                    type='horizontal'
                    style={{ margin: '0px 0px 20px' }}
                >
                    <span className='ss-cmpts-reg-header'>{
                        type === 'candidate' ? 'FTSP Candidate Registration'
                        : type === 'provider' ? 'FTSP Provider Registration'
                        : type === 'dod' ? 'FTSP DoD Registration'
                        : type === 'fsdo' ? 'FTSP FSDO Registration'
                        : type === 'recovery' ? 'FTSP Account Recovery'
                        : null
                    }</span>
                </Divider>
            </div>
        )
    }
}